<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu thu</h1>
      <div class="float-right btn-group sm-float-none">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="openImportModal">
          <i class="bx bx-add"></i> Cập nhật PT TMĐT theo lô
        </button>
        <!-- SCON_RECEIPT_IMPORT_ECOMMERCE -->
        <button
          @click="$router.push('/compare-import')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-upload"></i> Nhập file đối soát
        </button>
        <button
          @click="$router.push('/history-receipts')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-history"></i> Lịch sử nhập file đối soát
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('SCON_RECEIPT_VIEW')"
          @click="exportReceipts(keyDownload.CNPS_SCON_RECEIPT)"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('SCON_RECEIPT_VIEW')"
          @click="exportReceipts(keyDownload.CNPS_SCON_RECEIPT_BY_UNIT)"
        >
          <i class="bx bx-download"></i> Xuất file theo đơn vị
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('SCON_RECEIPT_ADD')"
          @click="receiptsAdd()"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian tạo </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="datePayment"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian thanh toán </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateApprove"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời duyệt phiếu thu </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.deviceSerial"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="search.transactionCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã giao dịch"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.superiorId" :options="dataManager" placeholder="Quản lý" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Nhân viên" />
          </div>

          <div class="form-group">
            <select2-multiple-control
              v-model="search.serviceType"
              :options="dataConfigService"
              :settings="{ placeholder: 'Dịch vụ' }"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.paymentType"
              :options="dataTypePayment"
              placeholder="Hình thức thanh toán"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.paymentMethod"
              :options="Config.getSearch(Config.paymentMethod)"
              placeholder="Phương thức"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="listState"
              placeholder="Trạng thái phiếu thu"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.refundStatus"
              :options="optionRefundStatus"
              placeholder="Hoàn tiền"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.invoiceSate"
              :options="Config.getSearch(Config.invoiceSate)"
              placeholder="Trạng thái xuất HĐ"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateInvoice"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian xuất HĐ </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.stateHandover"
              :options="Config.getSearch(Config.statusHandoverList)"
              placeholder="Trạng thái bàn giao TB"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.confirmInvoice"
              :options="Config.getSearch(Config.confirmInvoice)"
              placeholder="Verify TT MST"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateHandOver"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian bàn giao TB </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.typeCustomer"
              :options="Config.customerType"
              placeholder="Loại hợp đồng"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateSign"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder">
                  Thời gian ký HĐ/Phụ lục
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.sconState"
              :options="Config.getSearch(Config.listStatusContract)"
              placeholder="Trạng thái HĐ"
            />
          </div>

          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body" v-if="dataPermission && dataPermission.includes('SCON_RECEIPT_VIEW')">
        <div
          v-if="hasDefaultFilter"
          class="mb-2 d-inline-flex align-items-center"
          style="background-color: #fff3e0; padding: 6px 12px; border-radius: 4px; font-size: 13px"
        >
          <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
          <span style="color: #e65100">Đang lọc mặc định ngày hiện tại</span>
          <button
            @click="removeDefaultFilter"
            type="button"
            class="ml-2 btn-close-filter"
            style="
              background: none;
              border: none;
              cursor: pointer;
              padding: 0 4px;
              color: #e65100;
              font-size: 16px;
              line-height: 1;
            "
            title="Bỏ lọc"
          >
            ×
          </button>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng phiếu thu: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataReceipts"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <b>Tạo: </b> {{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                <b>Cập nhật: </b> {{ data.item.modifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(merchant)="data">
                {{ data.item.merchantName }}<br />
                {{ data.item.merchantMail }}<br />
                <a href="#">{{ data.item.merchanMobile | encryptPhone }}</a>
                <p v-if="data.item.typeCustomer"><b>Loại HĐ:</b> {{ data.item.typeCustomer }}</p>
              </template>
              <template #cell(receiptContractCode)="data">
                <a href="#" @click.prevent="showDetailContract(data.item)">
                  {{
                    (data.item.receiptContractCode ? data.item.receiptContractCode : '')
                      | splitContractCode_1
                  }}
                  <br />
                  {{
                    (data.item.receiptContractCode ? data.item.receiptContractCode : '')
                      | splitContractCode_2
                  }}
                </a>
                <p><b>Dịch vụ:</b></p>
                <div v-for="(itemm, indexx) in data.item.serviceTypes" :key="indexx">
                  <span v-if="itemm !== '0'">{{ itemm | serviceTypes }}</span>
                </div>
                <br />
                <p v-if="data.item.dateSign">
                  <b>Ngày ký:</b> {{ data.item.dateSign | formatDate }}
                </p>
                <p v-if="data.item.serialNumber"><b>Serial TB:</b> {{ data.item.serialNumber }}</p>
              </template>
              <template #cell(amount)="data">
                {{ data.item.amount | transformMoney }}
              </template>
              <template #cell(paymentType)="data">
                {{ data.item.paymentType | mapTextStatus(dataTypePayment) }}
                <div>
                  {{ data.item.paymentMethod === 'SDK_MPOS' ? 'Qua' : 'Không qua' }} SDK MPOS
                </div>
              </template>
              <template #cell(transactionCode)="data">
                <div v-if="data.item.transactionCode && data.item.transactionCode.length > 10">
                  {{ data.item.transactionCode | spitTransactionCode_1 }} <br />
                  {{ data.item.transactionCode | spitTransactionCode_2 }}
                </div>
                <div v-else>
                  {{ data.item.transactionCode }}
                </div>
              </template>
              <template #cell(receiptDate)="data">
                {{ data.item.receiptDate | formatDate }}
              </template>
              <template #cell(payDate)="data">
                {{ data.item.payDate | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(sale)="data">
                {{ data.item.saleName }} <br />
                {{ data.item.saleMail }}
              </template>
              <template #cell(invoiceStt)="data">
                <span class="badge CANCEL" v-if="data.item.invoiceCancel">
                  {{ 'Đã huỷ HĐ' }}
                </span>
                <span class="badge DONE" v-else>
                  {{ data.item.invoiceStt === true ? 'Đã xuất HĐ' : 'Chưa xuất HĐ' }} </span
                ><br />
                <span v-if="data.item.invoiceManual" class="mt-2">Tạo thủ công</span>
                <div v-if="data.item.invoiceCancelReason" class="mt-2">
                  Lý do huỷ: {{ data.item.invoiceCancelReason }}
                </div>
                <div v-if="data.item.invoiceExportDate" class="mt-2">
                  Thời gian xuất:
                  {{ data.item.invoiceExportDate | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </div>
              </template>
              <template #cell(stateHandover)="data">
                <span class="badge" :class="data.item.stateHandover">
                  {{ data.item.stateHandover | transformData(Config.statusHandoverList) }}
                </span>
                <div v-if="data.item.handoverDay" class="mt-2">
                  Thời gian BG: {{ data.item.handoverDay | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </div>
              </template>
              <template #cell(confirmInvoice)="data">
                <span class="">
                  {{ data.item.confirmInvoice | transformData(Config.confirmInvoice) }}
                </span>
              </template>
              <template #cell(refundStatus)="data">
                {{ data.item.refundStatus | mapTextStatus(optionRefundStatus) }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | mapTextStatus(listState) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="detailReceipt(data.item)"
                    ><i class="bx bx-search"></i><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    @click="editReceipts(data.item)"
                    v-if="
                      data.item.status != 'CANCEL' && dataPermission.includes('SCON_RECEIPT_UPDATE')
                    "
                  >
                    <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="receiptCancelInvoice(data.item)"
                    v-if="canReceiptCancelInvoice(data.item)"
                  >
                    <i class="bx bx-trash"></i><span>&nbsp;</span>Báo huỷ hoá đơn
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="canExportReceiptInvoice(data.item)"
                    @click="exportReceiptInvoice(data.item)"
                  >
                    <i class="bx bx-money"></i><span>&nbsp;</span>Xuất hoá đơn
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="
                      (data.item.status &&
                        data.item.status === 'NEW' &&
                        (data.item.paymentType === 'CUSTOMER_CARD' ||
                          data.item.paymentType === 'SALE_CARD') &&
                        dataPermission &&
                        dataPermission.includes('SCON_RECEIPT_COLLECT')) ||
                      (dataUser.typeSale === 'SALE_DIRECTOR' && data.item.status !== 'DONE')
                    "
                    @click="collectedMoney(data.item)"
                  >
                    <i class="bx bx-money"></i><span>&nbsp;</span>Thu tiền
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    @click="createRefund(data.item), refreshData()"
                    v-if="
                      data.item.status === 'DONE' &&
                      dataPermission.includes('CNPS_SCON_REFUND_CREATE')
                    "
                  >
                    <i class="bx bx-money"></i><span>&nbsp;</span>Hoàn tiền
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    @click="checkBeforeSendApprove(data.item)"
                    v-if="
                      data.item.status === 'NEW' && data.item.paymentType === 'CUSTOMER_TRANSFER'
                    "
                  >
                    <i class="bx bx-send"></i><span>&nbsp;</span>Gửi duyệt
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="
                      data.item.status === 'PENDING_APPROVAL' &&
                      dataPermission.includes('SCON_RECEIPT_APPROVE') &&
                      data.item.paymentType === 'CUSTOMER_TRANSFER'
                    "
                    @click="approveReceipt(data.item)"
                    ><i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="
                      (data.item.status === 'PENDING_APPROVAL' || data.item.status === 'DONE') &&
                      dataPermission.includes('SCON_RECEIPT_REJECT') &&
                      data.item.paymentType === 'CUSTOMER_TRANSFER'
                    "
                    @click="showRejectReceipts(data.item), (keyAction = 'REJECT')"
                    ><i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="
                      data.item.status !== 'CANCEL' &&
                      dataPermission.includes('SCON_RECEIPT_CANCEL')
                    "
                    @click="cancelReceipts(data.item), (keyAction = 'CANCEL')"
                    ><i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ phiếu thu
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    @click="markManualInvoice(data.item)"
                    v-if="dataPermission.includes('SCON_RECEIPT_MARK_INVOICE_MANUAL')"
                  >
                    <i class="bx bx-send"></i><span>&nbsp;</span>Đánh dấu xuất hđ thủ công
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="dropdown-item"
                    v-if="
                      dataPermission.includes('CNPS_SCON_SYNC_INVOICE_INFO') &&
                      ['DONE']?.includes(data.item.invoiceSate)
                    "
                    @click="showSyncReceiptModal(data.item)"
                  >
                    <i class="bx bx-sync"></i><span>&nbsp;</span>Đồng bộ dữ liệu phiếu thu
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <!--modal nhập lý do-->
    <b-modal id="reason-reject" centered v-model="reasonModal">
      <template #modal-header="{ close }">
        <h5>{{ keyAction === 'REJECT' ? 'Lý do từ chối' : 'Lý do huỷ phiếu thu' }}</h5>
        <b-button size="sm" variant="light" @click="close(), (dataInsert.reasonRejected = '')">
          x
        </b-button>
      </template>
      <div class="text-center">
        <form>
          <div class="form-group pos-relative">
            <textarea v-model="dataInsert.reasonRejected" class="form-control f12"></textarea>
          </div>
        </form>
      </div>
      <template #modal-footer="{}">
        <button
          :disabled="!dataInsert.reasonRejected || !dataInsert.reasonRejected.trim()"
          v-if="keyAction === 'REJECT'"
          @click="rejectReceipt"
          class="btn btn-success"
        >
          Xác nhận
        </button>
        <button
          :disabled="!dataInsert.reasonRejected || !dataInsert.reasonRejected.trim()"
          v-if="keyAction === 'CANCEL'"
          @click="submitCancelReceipts"
          class="btn btn-success"
        >
          Xác nhận
        </button>
      </template>
    </b-modal>

    <b-modal ignore-enforce-focus-selector="input" v-model="refundModal" centered size="lg">
      <template #modal-header="{ close }">
        <h5>Tạo thông tin hoàn tiền</h5>
        <b-button
          size="sm"
          variant="light"
          @click="close(), fetchFormRefund(), (refundModal = false)"
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formRefund">
        <form @submit.prevent="checkValidate">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="reason" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <select
                      class="select"
                      v-model="reqRefund.reason"
                      :options="refundReason"
                      disabled
                    >
                      <option v-for="option in refundReason" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="receiptCode" name="Mã phiếu thu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã phiếu thu</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.receiptCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã hợp đồng</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.contractCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Mã giao dịch đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">{{ reqRefund.transactionCode }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Hình thức thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.paymentType | mapTextStatus(optionPaymentType) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <ValidationProvider rules="required" vid="kpiStatus" name="Tình trạng KPI">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Tình trạng KPI</label>
                  <div class="col-sm-8">
                    <Select2 v-model="reqRefund.kpiStatus" :options="Config.kpiStatus"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqRefund.images" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqRefund.images && reqRefund.images.length < 10"
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileImgRefund"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <h6 class="mb-2">Thông tin thiết bị/phần mềm hoàn tiền</h6>
          <div class="row">
            <div class="table-responsive text-center col-md-12">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        v-model="selectProducts"
                        class="text-center"
                        @change="handleChange"
                      />
                    </th>
                    <th scope="col"><b>Loại sản phẩm</b></th>
                    <th scope="col"><b>Số tiền (VNĐ)</b></th>
                    <th scope="col" v-if="isRentLend"><b>Số tiền hoàn (VNĐ)</b></th>
                    <th scope="col"><b>Mã serial</b></th>
                    <th scope="col" v-if="isRentLend"><b>Khấu hao</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(item, index) in listProduct" :key="index">
                    <td class="txt-center">
                      <input
                        type="checkbox"
                        class="text-center"
                        v-model="selectedPro"
                        :value="item"
                        @change="handleChange"
                      />
                    </td>
                    <td class="text-center">{{ item.type }}</td>
                    <td class="text-center">
                      {{ (isRentLend ? item.deposit : item.price) | transformMoney }}
                    </td>
                    <td class="text-center" v-if="isRentLend">
                      <input
                        type="number"
                        min="0"
                        placeholder="Nhập tiền"
                        v-model="item.refundAmount"
                        :disabled="selectedPro.indexOf(item) === -1"
                        @input="onRefundAmountChange(item)"
                      />
                    </td>
                    <td class="text-center">{{ item.serial }}</td>
                    <td class="text-center" v-if="isRentLend">{{ item?.depreciationAmount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <ValidationProvider
              rules="required|numberCheck"
              vid="reqRefund.refundAmount"
              name="Số tiền hoàn"
            >
              <div class="form-group d-flex flex-row" slot-scope="{ errors }">
                <label for="" class="col-sm-5 col-form-label"
                  ><i>Tổng số tiền hoàn/phiếu thu (VNĐ)</i><span style="color: red"> *</span></label
                >
                <div class="col-sm-7">
                  <input v-model.trim="textValue" :disabled="isRentLend" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="refundRecipient" name="Đối tượng hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tượng hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefund.refundRecipient"
                      :options="objectRefund"
                      @change="queryObjectRefund($event)"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="bankName" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên ngân hàng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8" v-if="reqRefund.refundRecipient === 'REFUND_MERCHANT'">
                    <select
                      class="select"
                      :options="listBank"
                      v-model="reqRefund.bankName"
                      disabled
                    >
                      <option v-for="option in listBank" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                  <div class="col-sm-8" v-if="reqRefund.refundRecipient !== 'REFUND_MERCHANT'">
                    <Select2 :options="listBank" v-model="reqRefund.bankName"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountNumber"
                name="Số tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountNumber"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider rules="required|minMaxName_6" vid="branch" name="Chi nhánh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Chi nhánh <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.branch"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountName"
                name="Tên tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountName"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12">
              <ValidationProvider rules="required|minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-2 col-form-label"
                    >Ghi chú<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-10">
                    <input v-model.trim="reqRefund.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
      </template>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />
    <ModalimporPTTMDT ref="importModal" @onLoad="fetchData" />

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <b-modal id="sync-receipt-modal" centered v-model="syncReceiptModal">
      <template #modal-header="{ close }">
        <h5>Xác nhận đồng bộ dữ liệu phiếu thu</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <p>Bạn có chắc chắn muốn đồng bộ dữ liệu phiếu thu này không?</p>
        <p><strong>Mã phiếu thu:</strong> {{ selectedReceiptForSync?.receiptCode }}</p>
      </div>
      <template #modal-footer="{}">
        <button @click="syncReceiptModal = false" class="btn btn-secondary mr-2">Hủy</button>
        <button @click="confirmSyncReceiptData" class="btn btn-primary">Xác nhận</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { ReceiptService } from '@/services/receipts.service'
  import { BankService } from '@/services/bank.service'
  import { CommonService } from '@/services/common.service'
  import Config from '../../thirdParty/config'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import _ from 'lodash'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import ModalimporPTTMDT from './modalimporPTTMDT.vue'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'receiptCode', label: 'Mã phiếu thu' },
    { key: 'time', label: 'Ngày tạo' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'receiptContractCode', label: 'Số HĐ/PL' },
    { key: 'amount', label: 'Số tiền phải thu' },
    { key: 'paymentType', label: 'Hình thức thanh toán' },
    { key: 'transactionCode', label: 'Mã GD' },
    { key: 'receiptDate', label: 'Ngày đã thu' },
    { key: 'payDate', label: 'Ngày thanh toán' },
    { key: 'sale', label: 'CVKD' },
    { key: 'confirmInvoice', label: 'Verify TT MST' },
    { key: 'stateHandover', label: 'Trạng thái bàn giao' },
    { key: 'invoiceStt', label: 'Trạng thái hoá đơn' },
    { key: 'status', label: 'Trạng thái phiếu thu' },
    { key: 'refundStatus', label: 'Hoàn tiền' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  const keyDownload = {
    CNPS_SCON_RECEIPT: 'CNPS_SCON_RECEIPT',
    CNPS_SCON_RECEIPT_BY_UNIT: 'CNPS_SCON_RECEIPT_BY_UNIT',
  }
  export default {
    components: {
      DateRangePicker,
      ModalExportNoti,
      ModalimporPTTMDT,
    },
    data() {
      return {
        keyDownload,
        Config,
        reqRefund: {
          images: [],
          infoProducts: [],
        },
        syncReceiptModal: false,
        selectedReceiptForSync: null,
        listProduct: [],
        loadingImage: false,
        refundModal: false,
        refundReason: Config.refundReason,
        listBank: [],
        customerRes: {},
        objectRefund: Config.refundRecipient,
        // optionPaymentType: Config.typePayment,
        optionPaymentType: [],
        selectedPro: [],
        mailType: '',
        listMail: [],
        errorMail: '',
        listMailValid: [],
        fieldsTable,
        filterTable: fieldsTable,
        loading: true,
        showLoading: false,
        selected: [],
        selectAll: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listAfterSale: Config.listAfterSale,
        dataReceipts: [],
        dataProvince: [],
        optionsStaff: [],
        listUser: [],
        listState: [{ id: '0', text: 'Tất cả' }, ...Config.stateReceipt],
        listStateSearch: [],
        sourceCreate: [{ id: '0', text: 'Tất cả' }, ...Config.sourceCreate],
        dataConfigRegion: [],
        // dataTypePayment: [
        //   { id: '0', text: 'Tất cả' },
        //   ...Config.typePayment
        // ],
        dataTypePayment: [],
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataConfigService: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        hasDefaultFilter: false,
        isApplyingDefaultDateRange: false,
        stateSelected: '',
        dataInsert: {},
        cancelItem: {},
        rejectItem: {},
        reasonModal: false,
        dataManager: [],
        datePayment: {
          startDate: null,
          endDate: null,
        },
        dateApprove: {
          startDate: null,
          endDate: null,
        },
        dateInvoice: {
          startDate: null,
          endDate: null,
        },
        dateHandOver: {
          startDate: null,
          endDate: null,
        },
        dateSign: {
          startDate: null,
          endDate: null,
        },
        textValue: '',
        optionRefundStatus: [{ id: '0', text: 'Tất cả' }, ...Config.refundStatus],
        reasonCheck: '',
      }
    },

    mixins: [prepareQueryParamsMixin],

    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      splitContractCode_1(data) {
        if (data.includes('HĐĐT')) {
          const index = data.indexOf('HĐĐT')
          return data.substring(0, index + 5)
        } else {
          return data.substring(0, 17)
        }
      },
      splitContractCode_2(data) {
        if (data.includes('HĐĐT')) {
          const index = data.indexOf('HĐĐT')
          return data.length ? data.substring(index + 5, data.length) : ''
        } else {
          return data.length ? data.substring(17, data.length) : ''
        }
      },
      spitTransactionCode_1(data) {
        if (data.length && data.length > 10) return data.substring(0, 12)
        else return data
      },
      spitTransactionCode_2(data) {
        if (data.length && data.length > 10) return data.substring(12, data.length)
        else return data
      },
    },

    created() {
      this.getDataSearch()
      this.fetchData()
      this.getManager()
      this.getListStaffBySuperior()
      this.getRegions()
      this.configSystem()
      this.getListBank()
    },

    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      selectProducts: {
        get: function () {
          return this.listProduct ? this.selectedPro.length === this.listProduct.length : false
        },
        set: function (value) {
          var selectedPro = []
          if (value) {
            this.listProduct.forEach(function (item) {
              selectedPro.push(item)
            })
          }
          this.selectedPro = selectedPro
        },
      },
      isRentLend() {
        return this.reqRefund.reason === 'RENT_LEND' || this.reasonCheck === 'RENT_LEND'
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
        this.selectAll = false
      },
      selectedPro: {
        handler: function () {
          this.calculateTotalRefund()
        },
        deep: true,
      },
    },

    methods: {
      showSyncReceiptModal(item) {
        this.selectedReceiptForSync = item
        this.syncReceiptModal = true
      },

      async confirmSyncReceiptData() {
        try {
          this.showLoading = true
          this.syncReceiptModal = false

          const response = await ReceiptService.syncReceiptData({
            receiptId: this.selectedReceiptForSync.receiptId,
          })

          if (response.code === 1000) {
            this.showSuccessMx(response.message || 'Đồng bộ dữ liệu phiếu thu thành công')
            await this.fetchData()
          } else {
            this.showFailMx(response.message || 'Đồng bộ dữ liệu phiếu thu thất bại')
          }
        } catch (error) {
          console.log(error)
          this.showFailMx('Có lỗi xảy ra khi đồng bộ dữ liệu')
        } finally {
          this.showLoading = false
          this.selectedReceiptForSync = null
        }
      },
      openImportModal() {
        this.$refs.importModal.show()
      },

      createRefund(item) {
        this.infoRefund(item.receiptCode)
        this.reqRefund.receiptCode = item.receiptCode
        this.reqRefund.contractCode = item.description
        // this.reqRefund.reason = 'SOFTWARE_DEVICE'
        // this.reqRefund.reason = item.reason
      },
      async infoRefund(receiptCode) {
        try {
          this.showLoading = true
          const data = await BankService.merchantBank({
            code: receiptCode,
            reason: this.reqRefund.reason || this.reasonCheck,
          })
          if (data.success) {
            this.customerRes = data.data.customerRes
            this.listProduct = data.data.infoProducts
            // Ensure reason is set from API response or use reasonCheck if API doesn't return it
            this.$set(this.reqRefund, 'reason', data.data.reason || this.reasonCheck)
            this.$set(this.reqRefund, 'payTime', data.data.payTime)
            this.$set(this.reqRefund, 'paymentType', data.data.paymentType)
            this.$set(this.reqRefund, 'receiptTime', data.data.receiptTime)
            this.$set(this.reqRefund, 'contractCode', data.data.contractCode)
            this.$set(this.reqRefund, 'transactionCode', data.data.transactionCode)
            this.refundModal = true
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      fetchFormRefund() {
        this.reqRefund = {
          images: [],
        }
        this.selectedPro = []
        delete this.reqRefund.bankName
        delete this.reqRefund.accountNumber
        delete this.reqRefund.branch
        delete this.reqRefund.accountName
      },
      queryObjectRefund(e) {
        if (e === 'REFUND_MERCHANT') {
          this.reqRefund = {
            ...this.reqRefund,
            bankName: this.customerRes.bankId,
            accountNumber: this.customerRes.accountNo,
            branch: this.customerRes.branch,
            accountName: this.customerRes.holderName,
          }
        } else {
          delete this.reqRefund.bankName
          delete this.reqRefund.accountNumber
          delete this.reqRefund.branch
          delete this.reqRefund.accountName
        }
      },
      async onSelectFile() {
        const input = this.$refs.fileImgRefund
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      removeImg(index) {
        this.reqRefund.images.splice(index, 1)
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqRefund.images.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async checkValidate() {
        this.reqRefund.infoProducts = this.selectedPro
        this.reqRefund.bankId = this.reqRefund.bankName
        this.reqRefund.refundAmount = Number(this.textValue)

        // For RENT_LEND reason, validate that at least one checkbox is selected
        // if (this.reqRefund.reason === 'RENT_LEND' && this.selectedPro.length === 0) {
        //   this.showFailMx('Vui lòng chọn ít nhất một thiết bị/phần mềm để hoàn tiền')
        //   return
        // }

        const isSuccess = await this.$refs.formRefund.validate()
        if (!isSuccess && this.reqRefund.infoProducts.length < 1) {
          return
        }
        if (isSuccess) {
          if (this.reqRefund.reason === 'REFUND_MERCHANT') {
            this.addRefund(this.reqRefund)
          } else {
            this.checkBankAccount(this.reqRefund)
          }
        }
      },
      async checkBankAccount(reqRefund) {
        try {
          this.showLoading = true
          const data = await BankService.checkBank({
            bankId: reqRefund.bankName,
            holderName: reqRefund.accountName,
            accountNo: reqRefund.accountNumber,
          })
          if (data.success) {
            this.addRefund(reqRefund)
          } else {
            if (data.code === 641 || data.code === 642) {
              this.showLoading = false
              const flag = await this.approveMx(
                'Trong một số trường hợp dịch vụ kiểm tra thông tin phía ngân hàng không ổn định, thông báo này cũng sẽ được hiển thị. Nếu đã đảm bảo tính xác thực của thông tin, bạn có thể chọn tiếp tục?'
              )
              if (flag === true) {
                await this.addRefund(reqRefund)
              }
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async addRefund(reqRefund) {
        try {
          this.showLoading = true
          this.refundModal = false
          reqRefund.bankName = this.listBank.find(s => s.id === reqRefund.bankId)?.text ?? ''
          const data = await ReceiptService.createRefund(reqRefund)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx('Tạo thông tin hoàn tiền thành công')
          } else {
            this.showFailMx(data.message)
          }
          this.fetchFormRefund()
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      // chuyển trang chi tiết
      detailReceipt(item) {
        window.open(`/detail-receipts/${item.receiptId}`)
      },
      // chuyển trang sửa
      editReceipts(item) {
        if (
          item.createdBy === this.dataUser.userId ||
          this.dataUser.typeSale === 'SALE_DIRECTOR' ||
          (this.dataUser.typeSale === 'SALE_ADMIN' && item.status === 'PENDING_APPROVAL')
        ) {
          this.$router.push({ path: `/edit-receipts/${item.receiptId}/list` })
        } else {
          this.showFailMx('Bạn không có quyền sửa phiếu thu')
        }
      },
      receiptsAdd() {
        this.$router.push('/add-receipts')
      },

      async collectedMoney(item) {
        try {
          this.showLoading = true
          const response = await ReceiptService.collectedMoney({
            receiptId: item.receiptId,
            description: item.description,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async approveReceipt(item) {
        try {
          this.showLoading = true
          const response = await ReceiptService.approveReceipt({
            receiptId: item.receiptId,
            description: item.description,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
            await this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      showRejectReceipts(item) {
        this.reasonModal = true
        this.rejectItem = item
      },
      async rejectReceipt() {
        try {
          this.showLoading = true
          const response = await ReceiptService.rejectReceipt({
            receiptId: this.rejectItem.receiptId,
            rejectReason: this.dataInsert.reasonRejected,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
            await this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.reasonModal = false
          this.dataInsert.reasonRejected = ''
          this.showLoading = false
        }
      },

      cancelReceipts(item) {
        if (item.createdBy === this.dataUser.userId || this.dataUser.typeSale === 'SALE_DIRECTOR') {
          this.reasonModal = true
          this.cancelItem = item
        } else {
          this.showFailMx('Bạn chỉ được huỷ phiếu thu của mình')
        }
      },
      async submitCancelReceipts() {
        try {
          this.showLoading = true
          const response = await ReceiptService.cancelReceipt({
            receiptId: this.cancelItem.receiptId,
            rejectReason: this.dataInsert.reasonRejected,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
            await this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.reasonModal = false
          this.dataInsert.reasonRejected = ''
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          // this.search.userId = this.dataUser.userId
          if (this.search.regionId === '0') delete this.search.regionId
          if (this.search.cityCode === '0') delete this.search.cityCode
          if (this.search.serviceType === '0') delete this.search.serviceType
          if (this.search.saleId === '0') delete this.search.saleId
          if (this.search.transactionCode === '0') delete this.search.transactionCode
          if (this.search.paymentType === '0') delete this.search.paymentType
          if (this.search.paymentMethod === '0') delete this.search.paymentMethod
          if (this.search.status === '0') delete this.search.status
          if (this.search.superiorId === '0') delete this.search.superiorId
          if (this.search.refundStatus === '0') delete this.search.refundStatus
          if (this.search.invoiceSate === '0') delete this.search.invoiceSate

          // date
          if (this.dateInvoice.startDate) {
            this.search.invoiceStartDate =
              moment(this.dateInvoice.startDate).startOf('day').add(7, 'hours').valueOf() ?? null
            this.search.invoiceEndDate =
              moment(this.dateInvoice.endDate).endOf('day').add(7, 'hours').valueOf() ?? null
          }

          if (this.dateHandOver.startDate) {
            this.search.handOverFromDate =
              moment(this.dateHandOver.startDate).startOf('day').add(7, 'hours').valueOf() ?? null
            this.search.handOverToDate =
              moment(this.dateHandOver.endDate).endOf('day').add(7, 'hours').valueOf() ?? null
          }

          if (this.dateSign.startDate) {
            this.search.signFromDate =
              moment(this.dateSign.startDate).startOf('day').add(7, 'hours').valueOf() ?? null
            this.search.signToDate =
              moment(this.dateSign.endDate).endOf('day').add(7, 'hours').valueOf() ?? null
          }

          const params = _.cloneDeep(this.search)
          // remove data null and '0' and 'fasle'
          for (const key in params) {
            if (
              params[key] === null ||
              params[key] === '0' ||
              params[key] === 'false' ||
              (Array.isArray(params[key]) && params[key].length === 0)
            ) {
              delete params[key]
              delete this.search[key]
            }
          }
          // console.log(33, params)
          // return
          const data = await ReceiptService.getListReceipts(params)
          if (data.success) {
            this.dataReceipts = data.data
            this.pagination.total = data.totalPage.total ? data.totalPage.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.datePayment = {
          startDate: null,
          endDate: null,
        }
        this.dateApprove = {
          startDate: null,
          endDate: null,
        }
        this.dateInvoice = {
          startDate: null,
          endDate: null,
        }
        this.dateHandOver = {
          startDate: null,
          endDate: null,
        }
        this.dateSign = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.transformDate()
        this.search.page = 1
        this.fetchData()
      },

      async exportReceipts(key) {
        try {
          this.showLoading = true
          delete this.search.limit
          delete this.search.page
          const params = this.search
          const body = {
            object: params,
            type: key,
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      canExportReceiptInvoice(item) {
        // Trạng thái: Mới tạo | Chờ duyệt | Chờ kết toán | Đã thu tiền
        // - Trạng thái xuất hóa đơn: Chưa xuất hóa đơn
        // - Số tiền: Khác 0 đồng
        return (
          this.dataPermission.includes('SCON_RECEIPT_EXPORT_INVOICE') &&
          item.invoiceStt === false &&
          item.amount !== 0 &&
          ['NEW', 'PENDING_APPROVAL', 'DONE', 'WAIT_SETTLEMENT'].includes(item.status)
        )
      },
      async exportReceiptInvoice(item) {
        const check = this.canExportReceiptInvoice(item)
        if (!check) {
          this.showFailMx('Không có quyền truy cập')
          return false
        }
        try {
          this.showLoading = true
          const data = await ReceiptService.exportReceiptInvoice({ receiptId: item.receiptId })
          if (data.success) {
            this.mailType = ''
            this.errorMail = ''
            this.showSuccessMx(data.message)
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      // huỷ hoá đơn
      canReceiptCancelInvoice(item) {
        return (
          this.dataPermission.includes('SCON_INVOICE_CANCEL') &&
          item.invoiceStt &&
          !item.invoiceCancel
        )
      },
      async receiptCancelInvoice(item) {
        try {
          const check = this.canReceiptCancelInvoice(item)
          if (!check) {
            this.showFailMx('Không có quyền truy cập')
            return
          }
          const { value: flag, note } = await this.rejectMx('Nhập lý do báo huỷ hoá đơn')
          if (!flag) return
          const params = {
            receiptId: item.receiptId,
            reason: note,
          }
          this.showLoading = true
          const data = await ReceiptService.receiptCancelInvoice(params)
          if (data.code === 1000) {
            this.showLoading = false
            this.showSuccessMx(data.message)
            this.fetchData()
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.dataConfigRegion.push({ id: e.id, text: e.name })
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            const dataProvince = [{ id: 0, text: 'Tất cả' }]
            data.data.map(e => {
              dataProvince.push({ id: e.code, text: e.name })
            })
            this.dataProvince = dataProvince
          }
        } catch (error) {}
      },

      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return { id: e.id, text: e.name }
            })
            this.dataManager.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },

      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return { id: e.userId, text: e.name }
            })
            this.listUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigService = data.data.services.map(e => {
                return { id: e.code, text: e.name }
              })
              this.dataConfigService.unshift({ id: 0, text: 'Tất cả' })
              this.getListService()

              // paymentType
              this.dataTypePayment =
                data.data?.paymentType.map(e => {
                  return { id: e.code, text: e.name }
                }) || []
              this.optionPaymentType = this.dataTypePayment
              this.dataTypePayment.unshift({ id: 0, text: 'Tất cả' })
            }
          })
          .catch(error => console.log(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              this.dataConfigService = data[0].detail.map(e => {
                return { id: e.code, text: this.serviceTypes(e.name) }
              })
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      setDefaultCreatedDateRange() {
        const { from, to } = getLastNDays(1, 'date')
        this.isApplyingDefaultDateRange = true
        this.dateRange = {
          startDate: from,
          endDate: to,
        }
        this.transformDate()
        this.isApplyingDefaultDateRange = false
        this.hasDefaultFilter = true
      },

      transformDate() {
        if (this.dateRange.startDate && this.dateRange.endDate) {
          this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
          this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
          if (!this.isApplyingDefaultDateRange) {
            this.hasDefaultFilter = false
          }
        } else {
          delete this.search.startDate
          delete this.search.endDate
          if (!this.isApplyingDefaultDateRange) {
            this.hasDefaultFilter = false
          }
        }

        if (this.datePayment.startDate && this.datePayment.endDate) {
          this.search.paymentFromDate = moment(this.datePayment.startDate).startOf('day').valueOf()
          this.search.paymentToDate = moment(this.datePayment.endDate).endOf('day').valueOf()
        } else {
          delete this.search.paymentFromDate
          delete this.search.paymentToDate
        }

        if (this.dateApprove.startDate && this.dateApprove.endDate) {
          this.search.approveFromDate = moment(this.dateApprove.startDate).startOf('day').valueOf()
          this.search.approveToDate = moment(this.dateApprove.endDate).endOf('day').valueOf()
        } else {
          delete this.search.approveFromDate
          delete this.search.approveToDate
        }
      },

      checkBeforeSendApprove(item) {
        if (item.createdBy === this.dataUser.userId || this.dataUser.typeSale === 'SALE_DIRECTOR') {
          this.sendApproved(item)
        } else {
          this.showFailMx('Bạn chỉ được gửi duyệt phiếu thu của mình')
        }
      },

      async sendApproved(item) {
        try {
          this.showLoading = true
          const response = await ReceiptService.sendToApproveReceipt_detail({
            receiptId: item.receiptId,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
            await this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            limit: 20,
            page: 1,
          }
          this.setDefaultCreatedDateRange()
        } else {
          this.search = this.dataSearch
          this.hasDefaultFilter = false
          this.dateRange.startDate = this.search.startDate
            ? new Date(this.search.startDate).toString()
            : null
          this.dateRange.endDate = this.search.endDate
            ? new Date(this.search.endDate).toString()
            : null

          this.datePayment.startDate = this.search.paymentFromDate
            ? new Date(this.search.paymentFromDate).toString()
            : null
          this.datePayment.endDate = this.search.paymentToDate
            ? new Date(this.search.paymentToDate).toString()
            : null

          this.dateApprove.startDate = this.search.approveFromDate
            ? new Date(this.search.approveFromDate).toString()
            : null
          this.dateApprove.endDate = this.search.approveToDate
            ? new Date(this.search.approveToDate).toString()
            : null
          if (this.search.regionId) this.queryProvince(this.search.regionId)
          await this.fetchData()
        }
      },
      calculateTotalRefund() {
        if (this.isRentLend) {
          // Logic cho RENT_LEND: Tổng = tổng deposit của items được chọn + tổng refundAmount đã nhập
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            // const deposit = Number(item.deposit) || 0
            const refundAmount = Number(item.refundAmount) || 0
            return total + refundAmount
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        } else {
          // Logic cho các reason khác: Tổng = tổng price của items được chọn
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            const price = Number(item.price) || 0
            return total + price
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        }
      },

      handleChange(event) {
        this.calculateTotalRefund()
      },

      onRefundAmountChange(item) {
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },
      refreshData() {
        delete this.codeCheck
        delete this.transactionCheck
        delete this.reasonCheck
        delete this.reqRefund.bankId
        delete this.reqRefund.bankName
        delete this.reqRefund.accountNumber
        delete this.reqRefund.branch
        delete this.reqRefund.accountName
        delete this.reqRefund.refundRecipient
        delete this.reqRefund.note
        this.textValue = ''
      },
      showDetailContract(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },
      async markManualInvoice(item) {
        try {
          this.showLoading = true
          const response = await ReceiptService.sendMarkManualInvoice({
            receiptId: item.receiptId,
          })
          if (response.code === 1000) {
            this.showSuccessMx(response.message)
            await this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }

  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL,
  .WAIT_SETTLEMENT {
    color: #fff;
    background-color: #ffc107;
  }

  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }

  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }

  .badge {
    color: white;
  }

  .DONE,
  .ACTIVE,
  .SUCCESS {
    background-color: #007bff;
  }

  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    background-color: #ffc107;
  }

  .CANCEL,
  .REJECTED {
    background-color: #dc3545;
  }

  .UNSENT {
    color: black;
    background-color: #c7c7c7;
  }

  .SEND {
    background-color: #1a9e3f;
  }

  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
